export const navItemsArray =
    [
        {route: 'home', titleEn: 'Home', titleRu: 'О нас', titleHe: 'דף הבית'},
        {route: 'menu', titleEn: 'Menu', titleRu: 'Меню', titleHe: 'תפריט'},
        {route: 'events', titleEn: 'Events', titleRu: 'Концерты', titleHe: 'הופעות'},
        {route: 'gallery', titleEn: 'Gallery', titleRu: 'Галерея', titleHe: 'גלריה'}
     ];

export const navMenuItemsArray =
    [
        {route: 'bar', titleEn: 'Fluids', titleRu: 'Жидкости', titleHe: 'נוזלים'},
        {route: 'snacks', titleEn: 'Solid Fuel', titleRu: 'Твердое топливо', titleHe: 'דלק מוצק'},
        {route: 'dessert', titleEn: 'Sweet Fuel', titleRu: 'Сладкое топливо', titleHe: 'דלק מתוק'}
     ];

export const headerEn = {text: 'Welcome to “Stalkers Social Club”!\n' +
        'Here, the sound of freedom, friendship, and great vibes fills the air. We’re a place for everyone who loves lively evenings, live music, and a cozy atmosphere.\n' +
        'At “Stalkers Social Club,” you’ll find:\n' +
        ' • Live concerts: From rock and blues to alternative, for anyone who appreciates quality sound.\n' +
        ' • A welcoming vibe: Warmth and a sense of belonging for every guest.\n' +
        ' • Great drinks and food: Everything you need to make your evening unforgettable.\n' +
        'It doesn’t matter how you get here — on two wheels, four, or on foot — we welcome everyone who shares our love for music and good times!\n' +
        'See you at “Stalkers Social Club”!',
        subtext: 'We are waiting for you from Wednesday to Friday from 20-00 until 00-00 at the address Beer-Sheva st. Beit Eshel 17'};
export const headerRu = {text: 'Добро пожаловать в “Stalkers Social Club”!\n' +
        'Здесь звучит музыка свободы, дружбы и отличного настроения. Мы — место для всех, кто ценит яркие вечера, живую музыку и душевную атмосферу.\n' +
        'В “Stalkers Social Club” вас ждут:\n' +
        ' • Живые концерты: от рока и блюза до альтернативы, для всех, кто любит качественный звук.\n' +
        ' • Уютная атмосфера: тепло и душевность, где каждый почувствует себя своим.\n' +
        ' • Отличные напитки и еда: всё, чтобы ваш вечер стал незабываемым.\n' +
        'Не важно, на чём вы приехали — на двух колёсах, четырёх или пешком, — мы рады каждому гостю, кто готов разделить с нами любовь к музыке и хорошему время препровождению! До встречи в “Stalkers Social Club”!',
    subtext: 'Мы ждем вас со среды по пятницу c 20-00 до 00-00 по адресу г.Беэр-Шева ул. Бейт Эшель 17'};
export const headerHe = {text: 'ברוכים הבאים ל "Stalkers Social Club"\n' +
        ' כאן מארחים אותכם צלילי החופש, חברות ומצב רוח נהדר.  אנחנו מקום לכל מי שאוהב ערבים תוססים, מוזיקה חיה ואווירה נעימה.\n' +
        ' ב-"Stalkers Social Club", תמצאו:\n' +
        '   • קונצרטים חיים: מרוק ובלוז ועד מוזיקה אלטרנטיבית - לכל מי שמעריך סאונד איכותי.\n' +
        '   • אווירה מסבירת פנים: חום ותחושת שייכות לכל אורח.\n' +
        '   • משקאות ואוכל נהדרים: כל מה שאתה צריך כדי להפוך את הערב שלך לבלתי נשכח.\n' +
        ' לא משנה איך תגיעו לכאן - על שני גלגלים, על ארבעה, או רגלי - אנו מברכים את כל מי שחולק את האהבה שלנו למוזיקה ולבילוי טוב!',
    subtext: 'מחכים לכם מיום רביעי עד יום שישי בין השעות 20-00 עד 00-00 בכתובת באר שבע.'};

export const footerEn = {address: 'Address: Beer-Sheva, Beit Eshel 17',
    phone: 'Phone: 054-557-4713',
    work: 'Opening hours: from Wednesday to Friday from 20-00 until 00-00',
    copyright: 'All materials belong to StalkersSocialClub and their legal authors. When quoting, a link to the site is required.'};
export const footerRu = {address: 'Наш адрес: г. Беэр-Шева, ул. Бейт Эшель 17',
                            phone: 'Телефон: 054-557-4713',
                            work: 'График работы: со среды по пятницу с 20-00 до 00-00',
                            copyright: 'Все материалы принадлежат «StalkersSocialClub» и их законным авторам. При цитировании ссылка на сайт обязательна.'};
export const footerHe = {address: 'כתובתנו: באר שבע, רח\' בית אשל 17',
    phone: 'טלפון: 054-557-4713',
    work: 'שעות פתיחה: מיום רביעי עד יום שישי בין השעות 20-00 עד 00-00',
    copyright: 'כל החומרים שייכים ל-StalkersSocialClub ולמחברים המשפטיים שלהם. בעת הצעת מחיר יש צורך בקישור לאתר'};

export const eventRu = 'Бронирование мест 0545574713 - только WhatsApp!!!\n Укажите ваше имя, дату и название мероприятия, а так же количество мест.\n' +
    'Проверьте, что вам подтвердили бронь в чате WhatsApp!\n' +
    'Пожалуйста, уважайте артистов, организаторов и других желающих попасть на концерт, в случае, если вы не можете прийти на концерт, или у вас изменилось количество заказанных мест - сообщите нам в чате WhatsApp.\n' +
    'Увидимся у StalkerS!'
export const eventEn = 'Reservation of seats 0545574713 - WhatsApp only!\n' +
    'Please provide your name, event date, event name, and the number of seats you wish to book.\n' +
    'Make sure to check that your reservation has been confirmed in the WhatsApp chat.\n' +
    'Please respect the artists, organizers, and other attendees. If you are unable to attend the concert or need to change the number of reserved seats, kindly inform us in the WhatsApp chat.\n'+
    'See you at StalkerS!'
export const eventHE = 'הזמנת מקומות ב-0545574713 – רק בווצאפ\n' +
    'אנא ציינו את שמכם, תאריך האירוע ושם האירוע, וכן את מספר המקומות.\n' +
    'אנא ודאו שקיבלתם אישור להזמנה בצ\'אט של הווצאפ\n' +
    'אנא כבדו את האמנים, המארגנים ואת יתר האנשים המעוניינים להגיע לאירוע. אם אינכם יכולים להגיע או אם השתנה מספר המקומות שהזמנתם, אנא הודיעו לנו בצ\'אט של הווצאפ\n' +
    'נתראה ב StakerS';

